import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { catchError, firstValueFrom, throwError } from "rxjs";
import { TicketDto } from "@app/services/api/v1/visit/dto/ticket-dto";

@Injectable({
  providedIn: "root"
})
export class VisitRequirementsService {
  private http = inject(HttpClient);
  private clientConfigService = inject(ClientConfigService);

  /**
   * Retrieves a list of tickets for a given visit.
   *
   * @param visitId The ID of the visit
   * @returns A Promise that resolves to an array of TicketDto
   */
  public async getTicketsForVisit(visitId: number): Promise<TicketDto[]> {
    const config = this.clientConfigService.config;
    return firstValueFrom(
      this.http
        .get<TicketDto[]>(
          `${config.serviceUrl}/api/v1/visitRequirements/${visitId}/tickets`,
          {
            withCredentials: true
          }
        )
        .pipe(
          catchError((error) => {
            console.error(`Failed to get tickets for visit ${visitId}:`, error);
            return throwError(() => error);
          })
        )
    );
  }

  /**
   * Updates the tickets for a given visit with the provided list of TicketDto.
   *
   * @param visitId The ID of the visit
   * @param updatedTickets The new desired list of tickets
   * @returns A Promise that resolves to the updated array of TicketDto
   */
  public async updateTicketsForVisit(
    visitId: number,
    updatedTickets: TicketDto[]
  ): Promise<TicketDto[]> {
    const config = this.clientConfigService.config;
    return firstValueFrom(
      this.http
        .post<TicketDto[]>(
          `${config.serviceUrl}/api/v1/visitRequirements/${visitId}/tickets`,
          updatedTickets,
          {
            withCredentials: true
          }
        )
        .pipe(
          catchError((error) => {
            console.error(
              `Failed to update tickets for visit ${visitId}:`,
              error
            );
            return throwError(() => error);
          })
        )
    );
  }
}
